<template>
    <div>
        <modal
        name="showMFAModal"
        classes="v-modal-sec"
        :min-width="400"
        :min-height="400"
        :scrollable="true"
        :reset="true"
        width="400px"
        height="auto">
        <div class="v-modal profile_details_modal mfa_disable_modal">
            <div class="popup-header fromDetailsPage">
            <h2 class="popup-title">Multi-Factor Authentication</h2>
            <span  @click="hideMe()">
                <em class="material-icons">close</em>
            </span>
            </div>
            <form @submit.prevent>
                <div class="popup-accounts-content">
                    <div class="form-container padb20">
                        <div class="form_group">
                            <div class="vx-row">
                                <div class="vx-col w-full not_config">
                                    <!-- {{checkProperty(userDetails, 'email')}} -->
                                    <div class="form_group d-flex align-center justify-center"  v-if="checkProperty(userDetails, 'mfa')"> 
                                        <template v-if="checkProperty(userDetails, 'mfaType') === 'email'">
                                            <p class="form_label mb-0">Email</p>
                                        </template>
                                        <template v-if="checkProperty(userDetails, 'mfaType') === 'authenticator'">
                                            <p class="form_label mb-0">Authenticator App</p>
                                        </template>                                  
                                        <div class="table_switch mb-0 ml-4">
                                            <vs-switch class="mb-0" v-model="mfa">
                                                <span slot="on">Enable</span>
                                                <span slot="off">Disable</span>
                                            </vs-switch>
                                        </div>
                                    </div> 
                                    <template v-else>
                                        <p  class="text-center p-0" >
                                            <div class="text-center">
                                                <img src="@/assets/images/main/not_configured.png" />
                                            </div>
                                            <span class="no-config">Not configured</span>
                                        </p>
                                    </template>                                    
                                     
                                    
                                </div>
                                <div class="vx-col w-full" v-if="checkProperty(userDetails, 'lastLoggedIn')">
                                    <p class="last_login">Last successful login: {{ checkProperty(userDetails, 'lastLoggedIn')|formatDateTime }}<template v-if="checkProperty(userDetails, 'ipInfo', 'country')">, {{ checkProperty(userDetails, 'ipInfo', 'country') }}</template></p>
                                </div>
                            </div>
                        </div>
                        <div v-show="formError">
                            <vs-alert
                            color="warning"
                            class="warning-alert reg-warning-alert no-border-radius"
                            icon-pack="IntakePortal"
                            icon="IP-information-button"
                            active="true"
                            >{{ formError }}</vs-alert
                            >
                        </div>
                    </div>
                    <div class="popup-footer" v-if="checkProperty(userDetails, 'mfa')">
                        <div class="d-flex">
                            <vs-button color="dark" class="cancel" type="filled" @click="hideMe()">Cancel</vs-button>
                            <vs-button color=" success" class="save" type="filled" :disabled="mfa" @click="checkMfa()"> Submit</vs-button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        </modal>
        <vs-popup class="Change_petition_wrap cls-btn" title="Confirmation" v-if="openConfirmationPop" :active.sync="openConfirmationPop">
            <div class="Change_petition">
                <div class="form-container py-0">
                <div class="vx-row">
                    <div class="vx-col w-full">
                    <p class="text-center p-0">If Multi-Factor Authentication is disabled, the user will need to set it up again from the beginning.</p>
                    </div>
                </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" @click="closeConfirm()" class="cancel" type="filled">No
                </vs-button>
                <vs-button color="success"
                @click="updateMfa()" class="save" type="filled">Yes</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {

    },
    methods: {
        closeConfirm(){
            let self = this;
            this.openConfirmationPop=false;
            setTimeout(()=>{
                self.hideMe()
            })
        },
        checkMfa(){
            if(this.mfa == false){
                this.openConfirmationPop = true;
            }
        },
        updateMfa(){
            this.formError = '';
            let payLoad={
                userId:'',
                mfa:this.mfa  // mfaSetupEnable:this.mfa
            };
            if(this.callFromPetitioners){
                payLoad['userId'] = this.checkProperty(this.userDetails, 'petitionerUserDetails', '_id')
            }else{
                payLoad['userId'] = this.checkProperty(this.userDetails, '_id')
            }
            let path = '/mfa/disable-mfa';
            this.openConfirmationPop = false;
            this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((response)=>{
                this.showToster({ message: response.message, isError: false });
                this.hideMe(true)
            }).catch((err)=>{
                this.formError = err;
            })
        },
        hideMe(reload = false){
            this.openConfirmationPop = false;
            this.$emit('hideMfa', reload);
            this.$modal.hide('showMFAModal');
        },
    },
    data: ()=>({
        openConfirmationPop:false,
        mfa:false,
        formError:'',
        emailEnable:false,
        authenticatorEnable:false,
    }),
    props: {
        userDetails:{
            type:Object,
            default:null
        },
        petitionId:{
            type:String,
            default:''
        },
        callFromPetitioners:{
            type:Boolean,
            default:false
        }
    },
    computed:{

    },
    mounted(){
        if(this.checkProperty(this.userDetails, 'mfa')){
            this.mfa = this.checkProperty(this.userDetails, 'mfa');
        }else{
            this.mfa = false
        }
        this.$modal.show('showMFAModal')
    }
}
</script>